import React from 'react';
import { Input } from 'reactstrap';

export const Filter = ({ column, table }) => {
  const filterName = column?.columnDef?.Filter?.name;
  const getFilterComponent = (filterName) => {
    switch (filterName) {
      case 'DefaultColumnFilter':
        return <DefaultColumnFilter column={column} table={table} />;
      case 'DateRangeColumnFilter':
        return <DateRangeColumnFilter column={column} table={table} />;
      default:
        return <DefaultColumnFilter column={column} table={table} />;
    }
  };
  return (
    <div style={{ marginTop: 5 }}>
      {column.getCanFilter() && getFilterComponent(filterName)}
    </div>
  );
};

export const DefaultColumnFilter = ({ column, table }) => {
  const { setFilterValue, getFilterValue } = column;

  const filterValue = getFilterValue();
  return (
    <Input
      bsSize='sm'
      value={filterValue || ''}
      onChange={(e) => {
        setFilterValue(e.target.value || undefined);
      }}
      placeholder={`Search...`}
    ></Input>
  );
};

export const SelectColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <select
      id='custom-select'
      type='select'
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
    >
      <option value=''>Todos</option>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export function dateBetweenFilterFn(rows, id, filterValues) {
  const sd = filterValues[0] ? new Date(filterValues[0]) : undefined;
  const ed = filterValues[1] ? new Date(filterValues[1]) : undefined;
  if (ed || sd) {
    return rows.filter((r) => {
      // supporters date is YYYY-MM-DD
      var dateAndHour = r.getValues('date').split(' ');
      var [year, month, day] = dateAndHour[0].split('-');
      var date = [month, day, year].join('/');
      var hour = dateAndHour[1];
      var formattedData = date + ' ' + hour;
      const cellDate = new Date(r.getValues('date'));
      if (ed && sd) {
        return cellDate >= sd && cellDate <= ed;
      } else if (sd) {
        return cellDate >= sd;
      } else {
        return cellDate <= ed;
      }
    });
  } else {
    return rows;
  }
}

export const DateRangeColumnFilter = (column, table) => {
  const { getFilterValue, setFilterValue, id, getFilterFn } = column.column;
  const filterValue = getFilterValue();

  return (
    <div>
      <Input
        bsSize='sm'
        //min={min.toISOString().slice(0, 10)}
        onChange={(e) => {
          const val = e.target.value;
          setFilterValue((old = []) => [val ? val : undefined, old[1]]);
        }}
        type='date'
        value={false || ''}
      />
      {' to '}
      <Input
        bsSize='sm'
        //max={max.toISOString().slice(0, 10)}
        onChange={(e) => {
          const val = e.target.value;
          setFilterValue((old = []) => [
            old[0],
            val ? val.concat('T23:59:59.999Z') : undefined,
          ]);
        }}
        type='date'
        value={false || ''}
      />
    </div>
  );
};
